import React, { useState, useEffect } from 'react';
import api from '../api';

const JackpotHistory = () => {
  const [jackpotHistory, setJackpotHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const API = process.env.REACT_APP_API;
  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return date.toLocaleDateString('en-US', options);
  }

  useEffect(() => {
    const fetchJackpotHistory = async () => {
      try {
        const response = await api.get(`${API}/admin/jackpot-history`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setJackpotHistory(response);
      } catch (error) {
        console.error('Error fetching jackpot history:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchJackpotHistory();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading jackpot history...</div>;
  }

  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <h2 className="text-2xl font-bold text-white mb-4">Jackpot History</h2>
      
      {jackpotHistory.length === 0 ? (
        <p className="text-gray-400">No jackpot games have been played yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-white">
            <thead>
              <tr className="bg-gray-700">
                <th className="p-2 text-left">Date</th>
                <th className="p-2 text-right">Amount</th>
                <th className="p-2 text-left">Winner Card</th>
              </tr>
            </thead>
            <tbody>
              {jackpotHistory.map((game) => (
                <tr key={game._id} className="border-b border-gray-700">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">
                    {formatDate(game.createdAt)}
                </td>
                  <td className="p-2 text-right text-yellow-400">
                    {game.payoutToWinner.toLocaleString()} Birr
                  </td>
                  <td className="p-2">{game.winnerCard}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default JackpotHistory; 